import { render, staticRenderFns } from "./AttendanceIncentiveSetupNew.vue?vue&type=template&id=372b22c4"
import script from "./AttendanceIncentiveSetupNew.vue?vue&type=script&lang=js"
export * from "./AttendanceIncentiveSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports